export function aboutInit() {
    let videoModal = $('#about-video-modal').remodal();
    var videoPlayer = document.getElementById("video-embed");

    $('#about-video').on('click', function() {
        videoModal.open();
    });

    $(document).on('opened', '#about-video-modal', function() {
        console.log('Modal is opened');
        videoPlayer.play();
    });

    $(document).on('closing', '#about-video-modal', function(e) {
        videoPlayer.pause();

        // Reason: 'confirmation', 'cancellation'
        console.log('Modal is closing' + (e.reason ? ', reason: ' + e.reason : ''));
    });
}